import { createSelector } from 'reselect';
import { IRootState } from '../../state';

export const getActiveObject = createSelector(
  [(state: IRootState) => state.map.zoomableObjectList],
  (zoomableObjectList) => {
    return [...zoomableObjectList].sort((a, b) => b.priority - a.priority)[0];
  }
);
